import Vue from 'vue';
import IMP from './iamport';

Vue.use(IMP, 'imp09388674');
